import type { Edge } from '@/components/diagrams/FlowChart';
import type {
  DiagramNodeHistoryState,
  NodeHistorySupplement,
} from '@/components/diagrams/FlowChart/utils/nodeHistory';

import type { VisualizationGroup } from './grouping';

interface GroupHistoryState extends DiagramNodeHistoryState {
  edges: Edge[];
  visualizationGroups: VisualizationGroup[];
  hideEntitiesListInGroups: boolean;
}

type GroupHistorySnapshot = Pick<
  GroupHistoryState,
  'edges' | 'visualizationGroups' | 'hideEntitiesListInGroups'
>;

export function createGroupHistorySupplement<
  State extends GroupHistoryState,
>(): NodeHistorySupplement<State> {
  return {
    createSnapshot(snapshot, source) {
      if (
        snapshot.visualizationGroups === source.visualizationGroups &&
        snapshot.hideEntitiesListInGroups === source.hideEntitiesListInGroups
      ) {
        return undefined;
      }

      return {
        edges: snapshot.edges,
        visualizationGroups: snapshot.visualizationGroups,
        hideEntitiesListInGroups: snapshot.hideEntitiesListInGroups,
      } satisfies GroupHistorySnapshot;
    },
    restoreSnapshot(state, snapshot) {
      // This adapter restores only the snapshots it creates. Node history keeps
      // the payload opaque so shared diagram code does not depend on groups.
      const groupSnapshot = snapshot as GroupHistorySnapshot;
      return { ...state, ...groupSnapshot };
    },
  };
}
